import { render, staticRenderFns } from "./DataReviewList.vue?vue&type=template&id=30910646&scoped=true&"
import script from "./DataReviewList.vue?vue&type=script&lang=js&"
export * from "./DataReviewList.vue?vue&type=script&lang=js&"
import style0 from "./DataReviewList.vue?vue&type=style&index=0&id=30910646&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30910646",
  null
  
)

export default component.exports